import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { GalleryPage } from './pages/GalleryPage';
import { SettingsPage } from './pages/SettingsPage';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
function GlobalLogin({
  onLogin
}: {
  onLogin: () => void;
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (username === 'kasspi' && password === '2368') {
      onLogin();
    } else {
      setError('Nesprávné údaje.');
    }
  };
  return <div className="fixed inset-0 z-[9999] bg-off-white flex items-center justify-center px-6" data-id="element-0">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full border border-mist" data-id="element-1">
        <div className="flex justify-center mb-6" data-id="element-2">
          <div className="bg-mist p-4 rounded-full text-blue-medium" data-id="element-3">
            <LockIcon className="w-8 h-8" data-id="element-4" />
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-navy-deep text-center mb-2" data-id="element-5">
          Vstup pro pozvané
        </h1>
        <p className="text-navy-deep/60 text-center mb-8 text-sm" data-id="element-6">
          Projekt je v přípravě. Pro náhled se prosím přihlaste.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-7">
          <input type="text" placeholder="Jméno" value={username} onChange={e => setUsername(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-mist outline-none focus:border-blue-medium transition-all" data-id="element-8" />
          <input type="password" placeholder="Heslo" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-mist outline-none focus:border-blue-medium transition-all" data-id="element-9" />
          {error && <p className="text-red-500 text-sm text-center" data-id="element-10">{error}</p>}
          <button type="submit" className="w-full bg-blue-medium text-white py-3 rounded-lg font-medium hover:bg-blue-sky transition-colors" data-id="element-11">
            Vstoupit
          </button>
        </form>
      </motion.div>
    </div>;
}
export function App() {
  const [isAuthorized, setIsAuthorized] = useState(() => localStorage.getItem('fch_global_authorized') === 'true');
  const handleAuthorize = () => {
    setIsAuthorized(true);
    localStorage.setItem('fch_global_authorized', 'true');
  };
  if (!isAuthorized) {
    return <GlobalLogin onLogin={handleAuthorize} data-id="element-12" />;
  }
  return <div className="w-full min-h-screen bg-off-white flex flex-col" data-id="element-13">
      <Navigation data-id="element-14" />
      <div className="flex-grow" data-id="element-15">
        <Routes data-id="element-16">
          <Route path="/" element={<Home data-id="element-18" />} data-id="element-17" />
          <Route path="/galerie" element={<GalleryPage data-id="element-20" />} data-id="element-19" />
          <Route path="/nastaveni" element={<SettingsPage data-id="element-22" />} data-id="element-21" />
        </Routes>
      </div>
      <Footer data-id="element-23" />
    </div>;
}